import { render, staticRenderFns } from "./AttenBigScreen.vue?vue&type=template&id=d33ce4ce"
import script from "./AttenBigScreen.vue?vue&type=script&lang=js"
export * from "./AttenBigScreen.vue?vue&type=script&lang=js"
import style0 from "./AttenBigScreen.vue?vue&type=style&index=0&id=d33ce4ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports